import * as actionTypes from "../actions/actionTypes";

const init = {
  socket: null,
  loading : false
};
export const Socket = (state = init, action) => {
  switch (action.type) {
    case actionTypes.SETSOCKET :
      return {
          ...state,
          socket :action.state
      };
     case "socketLoading" :
      return {
          ...state,
          loading :action.state
      };
    default:
      return state;
  }
};

export default Socket;
